import React from 'react';
import cx from 'classnames';

const RequiredFieldsIndicator = ({ className = '' }: { className?: string }) => {
  return <div className={cx('text-xl', className)}>*Indicates required fields</div>;
};

export default RequiredFieldsIndicator;
